import { Record, Resource, SDK } from '@redge-media/fo-js-sdk';
import { ProductType } from '@/shared/enums';

const Products = Resource.extend({
  constructor: function Products(opts = {}) {
    Resource.call(this);

    this.category = opts.category;
    this.meta = {};
  },

  add(attrs = [], opts = {}) {
    const records = this.wrap(attrs);
    this.collection.add(records, opts);
  },

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize.call(this, response, opts);
    this.meta = data.meta || {};
    return data.items || data;
  },

  createRecord(props = {}, opts = {}) {
    if (props instanceof Record) {
      return props;
    }

    const item = props.item || props;
    item.pinned = props.pinned;
    return SDK.factory.resolve(item, opts);
  },

  getPath(method, opts) {
    const categoryType = this.category?.categoryType;

    if (method === 'fetch') {
      return `/items/${opts.id}`;
    }

    if (opts.translate) {
      return `/items/translate?${opts.translate.identifier}=${opts.translate.id}`;
    }

    if (categoryType === ProductType.LIVE) {
      if (opts.query) {
        return `products/lives/programmes/catalog?${opts.query}`;
      }

      return 'products/lives/programmes/catalog';
    }

    if (opts.contentFeed) {
      return `/products/content-feed/upsell/${opts.contentFeed}`;
    }

    if (opts.query) {
      return `/products/${categoryType.toLowerCase()}s?${opts.query}`;
    }

    return `/products/${categoryType.toLowerCase()}s`;
  },
});

export default Products;
